import React from 'react';
import { MessageSquare, Plus, Loader2 } from 'lucide-react';
import { Button } from '../../../ui/button';
import { Textarea } from '../../../ui/textarea';
import { Card, EmptyState, fmtDate, initialsOf } from './drawerShared';

export const NotesCard = ({ notes, canEdit, showForm, setShowForm, value, setValue, saving, onSubmit }) => {
  const addBtn = canEdit && (
    <Button size="sm" className="h-7 gap-1 border border-blue-200 bg-blue-50 text-xs font-semibold text-blue-700 shadow-none hover:bg-blue-100" onClick={() => setShowForm((v) => !v)} data-testid="notes-add-toggle">
      <Plus className="h-3 w-3" /> Add Interview Note
    </Button>
  );
  const ordered = [...notes].reverse();
  return (
    <Card title={`Interview Notes (${notes.length})`} icon={MessageSquare} action={addBtn} data-testid="drawer-notes-section">
      {showForm && (
        <div className="mb-4 space-y-2 rounded-lg border border-slate-200 bg-slate-50/70 p-3" data-testid="note-form">
          <Textarea rows={3} value={value} placeholder="Add interview feedback or notes…" className="bg-white text-sm" onChange={(e) => setValue(e.target.value)} data-testid="note-input" />
          <div className="flex justify-end gap-2">
            <Button variant="ghost" size="sm" onClick={() => { setShowForm(false); setValue(''); }}>Cancel</Button>
            <Button size="sm" onClick={onSubmit} disabled={saving || !value.trim()} data-testid="note-submit-btn">
              {saving && <Loader2 className="mr-1 h-3 w-3 animate-spin" />} Add Note
            </Button>
          </div>
        </div>
      )}
      {ordered.length === 0 ? (
        !showForm && <EmptyState icon={MessageSquare} title="No interview notes yet" hint="Capture feedback after each conversation so the whole team stays aligned." testId="notes-empty" />
      ) : (
        <ul className="divide-y divide-slate-100">
          {ordered.map((n) => (
            <li key={n.id} className="flex gap-3 py-3 first:pt-0 last:pb-0" data-testid="note-item">
              <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-slate-100 text-[11px] font-bold text-slate-600">{initialsOf(n.interviewer_name)}</div>
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-baseline justify-between gap-x-3">
                  <span className="text-xs font-semibold text-slate-800">{n.interviewer_name || 'Unknown'}</span>
                  <span className="text-[11px] text-slate-400">{fmtDate(n.interview_date || n.created_at)}</span>
                </div>
                <p className="mt-1 whitespace-pre-wrap text-sm leading-relaxed text-slate-700">{n.notes}</p>
              </div>
            </li>
          ))}
        </ul>
      )}
    </Card>
  );
};
